import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'

const TAB_KEY = 'basicInfo'
export default {
  name: 'basicInfo',

  computed: {
    basicInfoCreateConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          post: {
            module: 'administration',
            route: 'partner-groups',
            method: 'post'
          }
        },
        afterSave: () => this.backToMainTable(),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('administration/partner_group.new_group_details'),
            showBackButton: {
              onGoBack: () => {
                // exit from create mode to main table
                this.createMode = false
              }
            },
            onCancelTabSave: () => this.backToMainTable(false)
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('administration/partner_group.name'),
                    placeholder: this.$t('administration/partner_group.enter_group_name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    backToMainTable (refreshData = true) {
      // exit from create mode to main table
      this.createMode = false
      if (refreshData) {
        const { fetchData } = registeredTableHandlers?.partnerGroups || {}
        fetchData?.()
      }
    }
  }
}
